export default __webpack_public_path__ + "static/media/1620.555d262b.png";